import { loadScript } from '@shared/loadScript';
import { Markup } from '@shared/markdown/Markup';
import { ScriptsState } from '@shared/state/scripts';
import { onChange, state } from '@shared/state/store';
import { updateStore } from '@shared/state/updateStore';
import { ScheduledEvent, ScheduledScreen } from '@shared/types';
import { Component, h, Host, Prop, State } from '@stencil/core';
import { fetchEvents } from '../events/EventsService';
import { LoadingIndicator } from './LoadingIndicator';
import { Slide } from './Slide';
import { init } from './swiper';

const SLIDE_DURATION = 5 * 1000;

@Component({
  tag: 'slideshow-screen',
  styleUrl: 'slideshow-screen.scss'
})
export class SlideshowScreen {

  @Prop() screen: ScheduledScreen;
  @State() events: Array<ScheduledEvent> = [];

  async componentDidLoad() {
    const tryInit = ({ swipable }: ScriptsState) => {
      if (swipable === 'loaded') {
        init();
      }
    };

    fetchEvents().then(events => {
      if (events) {
        this.events = events;
        setTimeout(() => tryInit(state.scripts), 100);
      }
    });

    onChange('scripts', tryInit);

    if (state.scripts.swipable !== 'loaded') {
      updateStore('scripts', { swipable: 'loading' });
      await loadScript('https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js');
      updateStore('scripts', { swipable: 'loaded' });
    }
  }

  render() {
    const { events = [] } = this;
    const { events: scheduledEvents } = state;

    if (scheduledEvents.isBusy) {
      return (
        <Host class="w--100 h-100 row align--center align--center-v">
          <LoadingIndicator />
        </Host>
      );
    }

    return (
      <Host class='swiper overflow--hidden w--100 h--100'>
        <div class='swiper-wrapper row relative w--100 h--100'>
          {events.map(event => (
            <div
              class='swiper-slide no-shrink relative w--100 h--100'
              data-swiper-autoplay={SLIDE_DURATION}
            >
              <Slide key={event.title} cover={undefined}>
                <h1>{event.title}</h1>
                <Markup>{event.text}</Markup>
                <h3>{event.startDate}</h3>
                <h3>
                  <span>{event.startTime}</span>
                  <span>&nbsp; — &nbsp;</span>
                  <span>{event.endTime}</span>
                </h3>
              </Slide>
            </div>
          ))}
        </div>
      </Host>
    );
  }

}

/*
const slides = [
  {
    graphic: 'https://images.unsplash.com/photo-1690278843576-2a12195359d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80',
    duration: 5,
    markdown: `
# Hello,
* one
* two
    `
  },
  {
    graphic: 'https://images.unsplash.com/photo-1694383440534-83c739cf90c1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80',
    duration: 8,
    markdown: 'Another one'
  }
];
*/
